import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import Swiper from 'swiper';
import { SwiperComponent } from '../../../common/components';
import { NodeModel } from '../../../common/models';


@Component({
    selector: 'lib-insta-learn-posts-widget',
    templateUrl: './insta-learn-posts-widget.component.html',
    styleUrls: ['./insta-learn-posts-widget.component.scss'],
    standalone: false
})
export class InstaLearnPostsWidgetComponent implements OnInit, AfterViewInit {
  @ViewChild(SwiperComponent) public set swiperComponent(data: SwiperComponent) {
    this._swiperComponent = data;

    this.padItemsIfNeeded();
  }

  public get swiperComponent() {
    return this._swiperComponent;
  }

  @Input() public title: string;
  @Input() public description: string;
  @Input() public textColor: string;
  @Input() public items = [];
  @Input() public appendPlaceholders = false;

  @Input() public animation: string;
  @Input() public animationDelay = 0;

  @Output() public navigate: EventEmitter<NodeModel> = new EventEmitter();
  @Output() public openDialog: EventEmitter<number> = new EventEmitter();

  public swiperOptions = {}

  public displayItems = [];

  private _swiperComponent: SwiperComponent;

  constructor(
    private readonly dialog: MatDialog,
    private readonly element: ElementRef) { }

  ngOnInit(): void {
    this.init();
  }

  ngAfterViewInit(): void {
    this.addResizeObverveForContainer();
  }

  private padItemsIfNeeded() {
    this.displayItems = [...this.items];

    const swiper = this._swiperComponent?.swiper;

    if (!swiper || !this.appendPlaceholders) {
      swiper?.enable();
      return;
    }

    const capacity = this.calculateCapacity(swiper) + 1;

    this.items.length < capacity ? swiper.disable() : swiper.enable();

    if (this.items.length < capacity) {
      const missing = capacity - this.items.length;

      for (let i = 0; i < missing; i++) {
        this.displayItems.push(null);
      }
    }
  }

  private calculateCapacity(swiper: Swiper): number {
    const containerWidth = swiper.width;

    return Math.floor((containerWidth + +swiper.params.spaceBetween) / (144 + +swiper.params.spaceBetween));
  }

  private addResizeObverveForContainer(): void {
    if (!this.element.nativeElement) {
      return;
    }

    const observer = new ResizeObserver(() => {
      this.padItemsIfNeeded();
    });

    observer.observe(this.element.nativeElement);
  }

  private init(): void {
    this.padItemsIfNeeded();

    this.swiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      slidesPerGroup: 2,
      loop: false,
      breakpoints: {
        0: {
          slidesPerView: 2.6,
          spaceBetween: 16,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16
        },
        640: {
          slidesPerView: 'auto',
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        768: {
          spaceBetween: 20,
        },
        1024: {
          spaceBetween: 24
        }
      }
    }
  }
}
